import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  id: "lotto-wrapper",
  class: "contents-wrapper"
}
const _hoisted_2 = { id: "lotto-buy-list" }
const _hoisted_3 = { class: "page-head" }
const _hoisted_4 = { class: "page-head-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, "구매 내역", -1)
const _hoisted_6 = {
  key: 0,
  class: "page-sub"
}
const _hoisted_7 = {
  key: 0,
  class: "page-head-actions"
}
const _hoisted_8 = {
  key: 0,
  class: "progress-section section-card"
}
const _hoisted_9 = { class: "progress-header" }
const _hoisted_10 = { class: "progress-drw" }
const _hoisted_11 = { class: "progress-drw-no" }
const _hoisted_12 = { class: "progress-date" }
const _hoisted_13 = { class: "progress-layout" }
const _hoisted_14 = { class: "pl-left" }
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 0,
  class: "pl-stats stats-dashboard"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "pl-stats-title" }, "내 통계", -1)
const _hoisted_18 = { class: "stats-grid" }
const _hoisted_19 = { class: "stats-item" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "stats-label" }, "총 구매", -1)
const _hoisted_21 = { class: "stats-value" }
const _hoisted_22 = { class: "stats-sub" }
const _hoisted_23 = { class: "stats-item" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "stats-label" }, "총 당첨금", -1)
const _hoisted_25 = { class: "stats-value" }
const _hoisted_26 = { class: "stats-item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "stats-label" }, "수익률", -1)
const _hoisted_28 = { class: "stats-item" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "stats-label" }, "최고 등수", -1)
const _hoisted_30 = { class: "stats-value" }
const _hoisted_31 = {
  key: 0,
  class: "stats-rank-dist"
}
const _hoisted_32 = { class: "stats-rank-title" }
const _hoisted_33 = { class: "stats-rank-bars" }
const _hoisted_34 = { class: "stats-rank-label" }
const _hoisted_35 = { class: "stats-rank-track" }
const _hoisted_36 = { class: "stats-rank-count" }
const _hoisted_37 = {
  key: 0,
  class: "game-grid"
}
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  key: 1,
  class: "empty-progress"
}
const _hoisted_40 = {
  key: 2,
  class: "combo-section"
}
const _hoisted_41 = {
  key: 0,
  class: "combo-panel"
}
const _hoisted_42 = { class: "combo-pool" }
const _hoisted_43 = { class: "combo-pool-title" }
const _hoisted_44 = { class: "combo-pool-balls" }
const _hoisted_45 = { class: "combo-controls" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: 5 }, "5게임", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: 10 }, "10게임", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", { value: 15 }, "15게임", -1)
const _hoisted_49 = [
  _hoisted_46,
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = {
  key: 0,
  class: "combo-results"
}
const _hoisted_51 = { class: "combo-results-header" }
const _hoisted_52 = { class: "combo-results-title" }
const _hoisted_53 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, "🎟️", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "empty-text" }, "아직 구매 내역이 없어요", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "empty-sub" }, "번호를 만들어 저장하거나, 매장 용지의 QR을 불러와 기록해 보세요.", -1)
const _hoisted_57 = {
  key: 2,
  class: "past-divider"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("span", null, "지난 회차 구매내역", -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "round-header" }
const _hoisted_61 = { class: "round-drw" }
const _hoisted_62 = {
  key: 0,
  class: "win-numbers"
}
const _hoisted_63 = { class: "win-info" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "win-label" }, "당첨번호", -1)
const _hoisted_65 = { class: "win-date" }
const _hoisted_66 = { class: "win-balls" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "win-plus" }, "+", -1)
const _hoisted_68 = { class: "buy-group-time" }
const _hoisted_69 = { class: "game-grid" }
const _hoisted_70 = ["value"]
const _hoisted_71 = {
  key: 3,
  class: "loading-state"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "loading-text" }, "불러오는 중...", -1)
const _hoisted_74 = [
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = {
  key: 4,
  class: "end-state"
}
const _hoisted_76 = {
  key: 5,
  class: "delete-bar"
}
const _hoisted_77 = { class: "delete-bar-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LottoBuyGame = _resolveComponent("LottoBuyGame")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.statsData)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createTextVNode(" 총 " + _toDisplayString(_ctx.statsData.totalGames) + "게임 · 투자 " + _toDisplayString(_ctx.formatKRW(_ctx.statsData.totalInvestment)) + " · 회수 " + _toDisplayString(_ctx.formatKRW(_ctx.statsData.totalPrize)) + " ", 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["roi-badge", { positive: _ctx.statsData.roi > 0, negative: _ctx.statsData.roi < 0 }])
                }, _toDisplayString(_ctx.statsData.roi > 0 ? '+' : '') + _toDisplayString(_ctx.statsData.roi.toFixed(1)) + "%", 3)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.statsData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("button", {
                class: _normalizeClass(["edit-toggle-btn", { active: _ctx.editMode }]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleEditMode && _ctx.toggleEditMode(...args)))
              }, _toDisplayString(_ctx.editMode ? '완료' : '편집'), 3)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.progressDrwNo > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode("이번 회차 "),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.progressDrwNo) + "회차", 1)
              ]),
              _createElementVNode("div", _hoisted_12, "추첨일 " + _toDisplayString(_ctx.formatDrwDate(_ctx.progressDrwDate)), 1)
            ]),
            (_ctx.progressList.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstProgress, (game, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'p-' + idx,
                          class: _normalizeClass(["game-row", { 'edit-active': _ctx.editMode }])
                        }, [
                          (_ctx.editMode)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "checkbox",
                                class: "game-checkbox",
                                value: game.id,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedIds) = $event))
                              }, null, 8, _hoisted_15)), [
                                [_vModelCheckbox, _ctx.selectedIds]
                              ])
                            : _createCommentVNode("", true),
                          _createVNode(_component_LottoBuyGame, {
                            lottoGame: game,
                            editMode: _ctx.editMode,
                            onUpdateBuyType: _ctx.onUpdateBuyType
                          }, null, 8, ["lottoGame", "editMode", "onUpdateBuyType"])
                        ], 2))
                      }), 128))
                    ]),
                    (_ctx.statsData)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _hoisted_17,
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.statsData.totalGames) + "게임", 1),
                              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.formatKRW(_ctx.statsData.totalInvestment)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.formatKRW(_ctx.statsData.totalPrize)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("div", {
                                class: _normalizeClass(["stats-value", { positive: _ctx.statsData.roi > 0, negative: _ctx.statsData.roi < 0 }])
                              }, _toDisplayString(_ctx.statsData.roi > 0 ? '+' : '') + _toDisplayString(_ctx.statsData.roi.toFixed(1)) + "% ", 3)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.statsData.bestRank <= 5 ? _ctx.statsData.bestRank + '등' : '-'), 1)
                            ])
                          ]),
                          (_ctx.statsData.totalDrawnGames > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, "등수 분포 (추첨 완료 " + _toDisplayString(_ctx.statsData.totalDrawnGames) + "게임)", 1),
                                _createElementVNode("div", _hoisted_33, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4,5,6], (r) => {
                                    return _createElementVNode("div", {
                                      key: 'sr-' + r,
                                      class: "stats-rank-row"
                                    }, [
                                      _createElementVNode("span", _hoisted_34, _toDisplayString(r <= 5 ? r + '등' : '낙첨'), 1),
                                      _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["stats-rank-fill", 'rank-fill-' + r]),
                                          style: _normalizeStyle({ width: _ctx.getRankPercent(r) + '%' })
                                        }, null, 6)
                                      ]),
                                      _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.statsData.rankDist[r] || 0), 1)
                                    ])
                                  }), 64))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.restProgress.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restProgress, (game, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'pr-' + idx,
                            class: _normalizeClass(["game-row", { 'edit-active': _ctx.editMode }])
                          }, [
                            (_ctx.editMode)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "checkbox",
                                  class: "game-checkbox",
                                  value: game.id,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedIds) = $event))
                                }, null, 8, _hoisted_38)), [
                                  [_vModelCheckbox, _ctx.selectedIds]
                                ])
                              : _createCommentVNode("", true),
                            _createVNode(_component_LottoBuyGame, {
                              lottoGame: game,
                              editMode: _ctx.editMode,
                              onUpdateBuyType: _ctx.onUpdateBuyType
                            }, null, 8, ["lottoGame", "editMode", "onUpdateBuyType"])
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, "이번 회차 구매 내역이 아직 없어요")),
            (_ctx.progressList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["combo-toggle-btn", { active: _ctx.showCombo }]),
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleCombo && _ctx.toggleCombo(...args)))
                  }, " 내 번호 조합 ", 2),
                  (_ctx.showCombo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, "번호 풀 (" + _toDisplayString(_ctx.numberPool.length) + "개)", 1),
                          _createElementVNode("div", _hoisted_44, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberPool, (num) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'pool-' + num,
                                class: _normalizeClass(["combo-ball", _ctx.getColorClass(num)])
                              }, _toDisplayString(num), 3))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.comboCount) = $event)),
                            class: "combo-select"
                          }, _hoisted_49, 512), [
                            [_vModelSelect, _ctx.comboCount]
                          ]),
                          _createElementVNode("button", {
                            class: "combo-generate-btn",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.generateCombo && _ctx.generateCombo(...args)))
                          }, "생성")
                        ]),
                        (_ctx.comboGames.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("span", _hoisted_52, "조합 결과 (" + _toDisplayString(_ctx.comboGames.length) + "게임)", 1),
                                _createElementVNode("button", {
                                  class: "combo-save-btn",
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveCombo && _ctx.saveCombo(...args)))
                                }, "저장")
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comboGames, (game, idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: 'combo-' + idx,
                                  class: "game-row"
                                }, [
                                  _createVNode(_component_LottoBuyGame, {
                                    lottoGame: game,
                                    hideRank: true
                                  }, null, 8, ["lottoGame"])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.loading && _ctx.pastGroups.length === 0 && _ctx.progressList.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _hoisted_54,
            _hoisted_55,
            _hoisted_56,
            _createElementVNode("button", {
              class: "empty-cta",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goCreate && _ctx.goCreate(...args)))
            }, "번호 생성하러 가기")
          ]))
        : _createCommentVNode("", true),
      (_ctx.pastGroups.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, _hoisted_59))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pastGroups, (round) => {
        return (_openBlock(), _createElementBlock("div", {
          key: 'r-' + round.drwNo,
          class: "round-section section-card"
        }, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("span", _hoisted_61, _toDisplayString(round.drwNo) + "회차", 1),
            _createElementVNode("span", {
              class: _normalizeClass(["round-rank", round.bestRankClass])
            }, _toDisplayString(round.bestRankText), 3)
          ]),
          (_ctx.winNumberMap[round.drwNo])
            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.winNumberMap[round.drwNo].drwDate), 1)
                ]),
                _createElementVNode("div", _hoisted_66, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.winNumberMap[round.drwNo].numbers, (num, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'wn-' + round.drwNo + '-' + i,
                      class: _normalizeClass(["win-ball", _ctx.getColorClass(num)])
                    }, _toDisplayString(num), 3))
                  }), 128)),
                  _hoisted_67,
                  _createElementVNode("div", {
                    class: _normalizeClass(["win-ball", _ctx.getColorClass(_ctx.winNumberMap[round.drwNo].bonus)])
                  }, _toDisplayString(_ctx.winNumberMap[round.drwNo].bonus), 3)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(round.groups, (group, gIdx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'rg-' + round.drwNo + '-' + gIdx,
              class: "buy-group"
            }, [
              _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.formatBuyTime(group.time)), 1),
              _createElementVNode("div", _hoisted_69, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.games, (game, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'g-' + round.drwNo + '-' + gIdx + '-' + idx,
                    class: _normalizeClass(["game-row", { 'edit-active': _ctx.editMode }])
                  }, [
                    (_ctx.editMode)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "checkbox",
                          class: "game-checkbox",
                          value: game.id,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedIds) = $event))
                        }, null, 8, _hoisted_70)), [
                          [_vModelCheckbox, _ctx.selectedIds]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode(_component_LottoBuyGame, {
                      lottoGame: game,
                      editMode: _ctx.editMode,
                      onUpdateBuyType: _ctx.onUpdateBuyType
                    }, null, 8, ["lottoGame", "editMode", "onUpdateBuyType"])
                  ], 2))
                }), 128))
              ])
            ]))
          }), 128))
        ]))
      }), 128)),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_74))
        : _createCommentVNode("", true),
      (!_ctx.loading && _ctx.isLast && _ctx.buyList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, "마지막 구매내역입니다"))
        : _createCommentVNode("", true),
      (_ctx.editMode && _ctx.selectedIds.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
            _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.selectedIds.length) + "개 선택됨", 1),
            _createElementVNode("button", {
              class: "delete-bar-btn",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deleteSelected && _ctx.deleteSelected(...args)))
            }, "삭제")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}